import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["url"];
import bridge from './bridge';

/**
 * @description: 监听native回传数据
 * @param {string} eventName
 * 支持方法：
 * refreshPageData
 * getCameraData
 * getFileBase64
 * @param {function} cb
 */
function onEvent(eventName, cb) {
  try {
    bridge.registerHandler(eventName, function (data, responseCallback) {
      cb && cb(data, responseCallback);
    });
    console.log("onEvent=".concat(eventName, "\u89E6\u53D1\uFF01"));
  } catch (error) {
    console.log(error);
  }
}
/**
 * @description: 获取app注入的转发参数
 */
function getForwardData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('forwardInject', data, cb);
  } catch (error) {
    console.log(error);
  }
}
/**
 * @description: 返回上一页
 */
function getToken() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('getToken', data, cb);
    console.log('getToken触发！');
  } catch (error) {
    console.log(error);
  }
}
/**
 * @description: 返回上一页
 */
function goBackPage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    console.log(bridge, 'bridge');
    bridge.callHandler('goBackPage', data, cb);
    console.log('goBackPage触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 跳转新页面
 * @param {string} url 页面地址
 * @param {string} title 自定义标题
 * @param {number} isRefresh 当前页被返回时是否刷新 0不刷新 1刷新
 */
function newPageLink() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$isRefresh = _ref.isRefresh,
    isRefresh = _ref$isRefresh === void 0 ? 0 : _ref$isRefresh;
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('newPageLink', {
      url: url,
      title: title,
      isRefresh: isRefresh
    }, cb);
    console.log('newPageLink触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: token失效
 */
function tokenInvalid() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('tokenInvalid', data, cb);
    console.log('tokenInvalid触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 跳转实名认证
 */
function jumpRzPage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('jumpRzPage', data, cb);
    console.log('jumpRzPage触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 跳转主tab页面
 * @param {number}  tabType  tab编号 从0开始  eg：0-首页 1-发现 2-专题 3-我的
 */
function jumpTabPage() {
  var tabType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cb = arguments.length > 1 ? arguments[1] : undefined;
  try {
    bridge.callHandler('jumpTabPage', {
      tabType: tabType
    }, cb);
    console.log('jumpTabPage触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 跳转登录
 */
function jumpLogin() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('jumpLogin', data, cb);
    console.log('jumpLogin触发！');
  } catch (error) {
    console.log(error);
  }
}
/**
 * @description: 从nfr详情页兑换权益销毁nfr，返回跳过nfr详情页
 */
function destroyNfrDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('destroyNfrDetail', data, cb);
    console.log('destroyNfrDetail触发！');
  } catch (error) {
    console.log(error);
  }
}
/**
 * @description: 关闭当前webview
 */
function destroyCurrentPage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('destroyCurrentPage', data, cb);
    console.log('destroyCurrentPage触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 文案复制
 * @param {string} content 复制内容
 * @param {string} stateMessage 复制成功后的提示信息（可选）
 * @return:
 */
function copyContent() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$content = _ref2.content,
    content = _ref2$content === void 0 ? '' : _ref2$content,
    _ref2$message = _ref2.message,
    message = _ref2$message === void 0 ? '' : _ref2$message;
  var cb = arguments.length > 1 ? arguments[1] : undefined;
  try {
    bridge.callHandler('copyContent', {
      content: content,
      message: message
    }, cb);
    console.log('copyContent触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 唤醒选择相机拍照
 */
function openCamera() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 ? arguments[1] : undefined;
  try {
    bridge.callHandler('openCamera', data, cb);
    console.log('openCamera触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 截屏
 */
function saveScreenshot() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 ? arguments[1] : undefined;
  try {
    bridge.callHandler('saveScreenshot', data, cb);
    console.log('saveScreenshot触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 打开文件预览
 * @param {string} atIndex 当前打开的index
 * @param {string} data 预览数据  包含 url 和 type 两个属性
 */
function filePreview() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$atIndex = _ref3.atIndex,
    atIndex = _ref3$atIndex === void 0 ? 0 : _ref3$atIndex,
    _ref3$data = _ref3.data,
    data = _ref3$data === void 0 ? [] : _ref3$data;
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('filePreview', {
      atIndex: atIndex,
      data: data
    }, cb);
    console.log('filePreview触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 保存相册
 * @param {string} base64Str: 文件地址 （obs/base64）
 * @param {string} type 朋友圈 WXSceneTimeline 微信好友 WXSceneSession
 */
function saveFile() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$base64Str = _ref4.base64Str,
    base64Str = _ref4$base64Str === void 0 ? '' : _ref4$base64Str,
    _ref4$type = _ref4.type,
    type = _ref4$type === void 0 ? '' : _ref4$type;
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('saveFile', {
      base64Str: base64Str,
      type: type
    }, cb);
    console.log('saveFile触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 分享朋友圈，微信好友
 * @param {string} base64Str 文件地址 （obs/base64）
 * @param {string} type 朋友圈 WXSceneTimeline 微信好友 WXSceneSession
 * @param {string} content 分享文字内容
 */
function sharePageLink() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref5$base64Str = _ref5.base64Str,
    base64Str = _ref5$base64Str === void 0 ? '' : _ref5$base64Str,
    _ref5$type = _ref5.type,
    type = _ref5$type === void 0 ? '' : _ref5$type,
    _ref5$content = _ref5.content,
    content = _ref5$content === void 0 ? '' : _ref5$content;
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('sharePageLink', {
      base64Str: base64Str,
      type: type,
      content: content
    }, cb);
    console.log('sharePageLink触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 打开app内某一个页面
 * @param path 需要编码的参数 ucopyright://exhibition/{personal}(public)/ {userId}
 * @param cb 调用回调
 * */
function openPage() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('openPage', {
      path: path
    }, cb);
    console.log('path=', path);
    console.log('openPage触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 打开外部浏览器
 * */
function openNativeBrowser(_ref6) {
  var url = _ref6.url,
    other = _objectWithoutProperties(_ref6, _excluded);
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('openNativeBrowser', _objectSpread({
      url: url
    }, other), cb);
    console.log('openNativeBrowser！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 切换app主题
 * @param theme
 * @param cb 调用回调
 * */
function switchTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('switchTheme', {
      theme: theme
    }, cb);
    console.log('switchTheme！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 获取app状态栏+导航栏高度
 */
function getNavBarTop() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('getNavBarTop', data, cb);
    console.log('getNavBarTop触发！');
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description: 获取app使用支付宝H5支付时的 paySign 回调 body
 */
function getAliPayBody() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  try {
    bridge.callHandler('getAliPayBody', data, cb);
    console.log('getAliPayBody触发！');
  } catch (error) {
    console.log(error);
  }
}
export default {
  onEvent: onEvent,
  getToken: getToken,
  getForwardData: getForwardData,
  goBackPage: goBackPage,
  newPageLink: newPageLink,
  tokenInvalid: tokenInvalid,
  jumpRzPage: jumpRzPage,
  jumpTabPage: jumpTabPage,
  jumpLogin: jumpLogin,
  destroyCurrentPage: destroyCurrentPage,
  saveFile: saveFile,
  copyContent: copyContent,
  openCamera: openCamera,
  saveScreenshot: saveScreenshot,
  filePreview: filePreview,
  sharePageLink: sharePageLink,
  openPage: openPage,
  openNativeBrowser: openNativeBrowser,
  switchTheme: switchTheme,
  destroyNfrDetail: destroyNfrDetail,
  getNavBarTop: getNavBarTop,
  getAliPayBody: getAliPayBody
};